import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Breadcrumbs, I18N, Loader } from '@/components';
import { useSnackbar } from '@/contexts/SnackbarContext';
import { CompanyForm } from '@/forms';
import { ApiException, useApi } from '@/hooks/useApi';
const CompanyCreationPage = () => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const { callApi } = useApi();
    const { showError } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const handleSubmit = useCallback(async (data) => {
        setLoading(true);
        delete data.name;
        try {
            const response = await callApi('POST', '/companies', data);
            if (response && typeof response === 'object' && 'id' in response) {
                navigate(`/companies/${response.id}`, { replace: true });
            }
        }
        catch (e) {
            const detail = e instanceof ApiException && e.detail;
            showError(detail || 'companies.messages.createError');
        }
        finally {
            setLoading(false);
        }
    }, [callApi, navigate, showError]);
    return (_jsxs("div", { className: "p-2 md:max-w-[800px] mx-auto", id: "company-creation-page", children: [_jsxs(Breadcrumbs, { children: [_jsx(Link, { replace: true, to: "/companies", children: _jsx(I18N, { children: "navigation.companies" }) }), _jsx(Link, { replace: true, to: "/companies/new", children: _jsx(I18N, { children: "common.new" }) })] }), _jsx(CompanyForm, { defaultValues: {
                    hubspotId: '',
                    name: '',
                    notes: '',
                    owner: params.get('ownerId') ?? null,
                }, mode: "onChange", onSubmit: handleSubmit, onCancel: () => navigate('/companies', { replace: true }), submitting: loading, children: _jsx(I18N, { children: "companies.newCompany" }) }), _jsx(Loader, { loading: loading })] }));
};
export default CompanyCreationPage;
